module.exports = __webpack_public_path__ + "media/during_result.ca0f7f6d.mp3";